// https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

function reportError(e: unknown) {
  // TODO: use a logging service instead of console
  // eslint-disable-next-line no-console
  console.log(getErrorMessage(e));
}

export { getErrorMessage, reportError };
